import { isValidUuId } from '@shared/utils/uuid';
import { PartnerHotelDetailsRouteQueryParams, PartnerHotelIdType } from '../HotelBooking.types';
import { useQueryParamHelper } from '@shared/core/queryString';

export const usePartnerHotelQueryParams = (travelPlaceIdArg?: string | null) => {
  const queryParamHelper = useQueryParamHelper();

  // Retrieve query parameters
  const getQueryParam = (param: PartnerHotelDetailsRouteQueryParams) => queryParamHelper.getValueString(param);

  // @todo - Cleanup with ticket - https://withjoy.atlassian.net/browse/TRAV-622
  const travelPlaceId = travelPlaceIdArg || getQueryParam(PartnerHotelDetailsRouteQueryParams.joyPlaceId);

  const idTypeParam = getQueryParam(PartnerHotelDetailsRouteQueryParams.idType) || '';
  const isValidHotelIdType = !!PartnerHotelIdType[idTypeParam as PartnerHotelIdType]; // Validate is valid idtype
  const sourceType = isValidUuId(travelPlaceId) ? PartnerHotelIdType.joy : isValidHotelIdType ? (idTypeParam as PartnerHotelIdType) : PartnerHotelIdType.hotels; // convert value to HotelIdType
  const source = getQueryParam(PartnerHotelDetailsRouteQueryParams.source);

  const queryParamEventId = getQueryParam(PartnerHotelDetailsRouteQueryParams.eventId);
  const utmParams = {
    utm_source: getQueryParam(PartnerHotelDetailsRouteQueryParams.utm_source),
    utm_source_secondary: getQueryParam(PartnerHotelDetailsRouteQueryParams.utm_source_secondary),
    utm_medium: getQueryParam(PartnerHotelDetailsRouteQueryParams.utm_medium),
    utm_campaign: getQueryParam(PartnerHotelDetailsRouteQueryParams.utm_campaign),
  };

  const discountCode = getQueryParam(PartnerHotelDetailsRouteQueryParams.discountCode);

  return { travelPlaceId, sourceType, source, queryParamEventId, utmParams, discountCode };
};
